export default __webpack_public_path__ + "static/media/GeneralIcon.726ae4bd.svg";